import { createApp } from "vue";
import App from "./App.vue";
import InlineSvg from "vue-inline-svg";
// import { defineCustomElement } from "vue";

const app = createApp(App);
app.component("inline-svg", InlineSvg);

let element = document.querySelector("#host")?.shadowRoot.querySelector("div");
const target = element || document.querySelector("#app");
app.mount(target);
